<div class="bl-row card-margin">
  <div class="bl-col-1 bl-col-sm-1">
    <i class="bl-margin-right--4 bl-font-size--24" [ngClass]="getDisclosureSelectedStatus()"></i>
  </div>
  <div class="bl-col-11 bl-col-sm-11 bl-padding-left--0 bl-padding-right--0">
    <h2 class="bl-font-weight--900 bl-flex--auto bl-font-color--black bl-font-size--28 bl-margin-bottom--0">Terms & Conditions</h2>
    <div class="bl-font-size--14 bl-font-color--error" *ngIf="!allDisclosuresAccepted() && (pageSubmitted$ | async)">Required</div>

    <div class="bl-margin-y--16">Please review the following documents:</div>

    <div class="bl-col-9 bl-col-sm-10 bl-padding-left--0 bl-padding-right--0">
      <div *ngFor="let disclosure of disclosures; let i = index" class="" id="smart-sign-disclosure-{{ i }}">
        <!-- Disclosure open poupup -->
        <div *ngIf="!disclosure.isLinkType" class="bl-margin-top--8">
          <div class="bl-margin-bottom--16">
            <button
              id="open-disclosure-panel"
              class="disclosureLink bl-text-decoration--underline"
              (click)="chkSelection(disclosure, i); openSlideInPanel(disclosure)"
            >
              {{ disclosure.title }}
            </button>
          </div>
        </div>

        <div *ngIf="disclosure.isLinkType" class="bl-margin-bottom--16">
          <a [href]="disclosure.url" class="disclosureLink" target="_blank" (click)="chkSelection(disclosure, i)">{{
            disclosure.urlDisplayText
          }}</a>
        </div>
      </div>
    </div>
    <div class="bl-margin-y--16" [innerHTML]="this.utilitiesService.normalizeSpaces(disclosure?.placeHolderAcceptText)"></div>

    <div class="bl-flex--auto">
      <ng-container *ngIf="isArray(disclosure.applicants)">
        <div *ngFor="let applicant of disclosure.applicants; let index = index">
          <div
            class="bl-display--flex bl-width--100 bl-flex-flow--wrap"
            [ngClass]="disclosure.applicants.length - 1 != index ? 'bl-padding-right--32' : ''"
          >
            <ng-container *ngIf="isOAOFlow">
              <div
                class="bl-font-color--error bl-font-size--14 bl-margin-bottom--16"
                aria-label="error"
                aria-live="assertive"
                *ngIf="!applicant.accepted && !requiredValidation() && (pageSubmitted$ | async)"
              >
                {{ getApplicantLabel(applicant.applicant) }} {{ 'smartSignReview/errorMessageCheckbox' | dictionary }}
              </div>
              <div
                class="bl-font-color--error bl-font-size--14 bl-margin-bottom--16"
                aria-label="error"
                aria-live="assertive"
                *ngIf="requiredValidation()"
              >
                {{ 'smartSignReview/errorMessage' | dictionary }}
              </div>
            </ng-container>
          </div>

          <div class="bl-check-wrap bl-margin-bottom--16">
            <input type="checkbox" id="smart_sign_disclosure_acc_{{ index }}" #name="ngModel" [(ngModel)]="applicant.accepted"
            (change)="updateAcceptance(disclosure.applicants, '' + index, index, $event); keepCheckboxFocus('' + index)"
            [required]="getAllowToAccept(disclosure)" [disabled]="showRequiredValidationMessage()"
            (focus)="storeOriginalCheckboxValue('' + index, $event)"/>
            <label for="smart_sign_disclosure_acc_{{ index }}" class="bl-label">
              <span class="bl-required bl-font-size--14 bl-font-weight--900" 
                [innerHTML]="isApplicantExists(applicant.applicant) ? getApplicantLabel(applicant.applicant) : ('smartSignReview/acceptLabel' | dictionary)">
              </span>
              <span *ngIf="isApplicantExists(applicant.applicant)" class="bl-font-size--14 bl-display--block"
                [innerHTML]="index === 0 ? 'Primary Applicant' : 'Co-Applicant'">
              </span>
            </label>
          </div>
        </div>
      </ng-container>
    </div>

    <ea-slide-in-panel
      class="full-panel"
      [(isSlidePanelVisible)]="isOpen"
      [slidePanelTitle]="docTitle"
      [fixedLayout]="true"
      openPanelElementId="open-smart-sign-disclosure-panel"
    >
      <div *ngIf="isOpen" class="bl-border bl-border-radius bl-bg-color--white bl-padding-x--16 bl-padding-y--24 bl-padding-md--32">
        <ng-container *ngIf="isDataloaded">
          <div class="bl-display--flex bl-justify-content--flex-end bl-margin-bottom--16 bl-height--100">
            <h4 class="bl-margin-bottom--0 bl-font-weight--900 bl-font-color--black bl-font-size--18 bl-margin-right--auto">
              {{ 'smartSignReview/review' | dictionary }}
            </h4>
            <button
              *ngIf="isDataloaded && pdfURL"
              (click)="printPDF()"
              id="smart-sign-printPDF-disclosure"
              class="bl-padding-right--24 bl-font-color--steel"
            >
              <i class="cu-print bl-padding-right--8 bl-font-color--primary" alt="" aria-hidden="true"></i>
              <span>{{ 'smartSignReview/print' | dictionary }}</span>
            </button>

            <button *ngIf="isDataloaded && pdfURL" (click)="downloadPDF()" id="smart-sign-download-disclosure" class="bl-font-color--steel">
              <i class="cu-inbox-download bl-padding-right--8 bl-font-color--primary" alt="" aria-hidden="true"></i>
              <span>{{ 'smartSignReview/download' | dictionary }}</span>
            </button>
          </div>
          <div class="bl-padding--16 bl-position--relative" *ngIf="isDataloaded && pdfURL">
            <ecp-pdf-embed [pdfSrc]="pdfURL"></ecp-pdf-embed>
          </div>
          <div [innerHTML]="content" *ngIf="content"></div>
        </ng-container>
        <ng-container *ngIf="isOpen && !isDataloaded">
          <div class="bl-padding--16 bl-position--relative">
            <p class="bl-margin-y--24 bl-font-color--steel" [innerHTML]="'smartSignReview/loadingText' | dictionary"></p>
            <ecp-content-spinner [spinnerSmall]="true"></ecp-content-spinner>
          </div>
        </ng-container>
      </div>
    </ea-slide-in-panel>
  </div>
</div>
